<template lang="pug">
  .component-selectize-client
    selectize(v-if="options", :options="options", value-field="id", :maxItems="maxItems" label-field="name", :items="items" :searchField="searchableFields", :optionTemplate="optionTemplate", :renderTemplate="renderTemplate", @itemAdded="optionSelected", placeholder="Driver Licenses")
</template>

<script>
  import Selectize from "../../../Selectize";
  import BaseSelectize from './BaseSelectize'
  import KeplerBackofficeSdk from "../../../../../lib/kepler/backoffice";

  export default {
    name: "SelectizeDriverLicense",
    extends: BaseSelectize,
    components: {Selectize},
    data() {

      return {
        searchableFields: ['id', 'name']
      }
    },
    created() {
      this.options = [{id: "VEWwEX", name: 'Patente b'}]

    },
    methods: {
      optionTemplate(item, escape) {
        return `<div><div><small>DL${item.id}</small></div><div>${item.name}</div></div>`
      },
      renderTemplate(item, escape) {
        return `<div>${item.name}</div>`
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// SelectizeDriverLicense.vue?a3230654